import { render, staticRenderFns } from "./ClientAccountEdit.vue?vue&type=template&id=7bc53fb5&"
import script from "./ClientAccountEdit.vue?vue&type=script&lang=ts&"
export * from "./ClientAccountEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports